import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui canonical `cn` helper — combines clsx + tailwind-merge so
 * conditional + later-wins Tailwind classes resolve correctly.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
